<template>
  <div class="app-layout">
    <v-app style="background-color: rgb(252,252,255)">
      <v-main>
        <transition name="page" mode="out-in">
          <slot></slot>
        </transition>
      </v-main>
    </v-app>
  </div>
</template>

<style lang="less">
.app-layout {
  @import (less) '../../node_modules/vuetify/dist/vuetify.min.css';
}
</style>

<script lang="ts">
import {defineComponent} from '@vue/composition-api'

export default defineComponent({
  name: 'App',

  setup() {

  }
})
</script>
